import { Dispatch } from 'redux';
import { RootState } from '../reducers/store';
import { UserReducerActionType } from '../reducers/userReducer';
import { UserDataType } from '../types';

// Types des actions de récupération des données du user
export const FETCH_ME = 'fetch_me';

export const fetchMe =
  () =>
  async (
    dispatch: Dispatch<UserReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get<{ data: UserDataType }>('/me', ({ data }) =>
      dispatch({ type: FETCH_ME, payload: data })
    );
  };
